
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "LoadingPage",
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      defualt: false,
    },
    tip: {
      type: String,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const data = computed(() => props.isLoading);
    const tipTxt = computed(() => props.tip);
    return {
      data,
      tipTxt,
    };
  },
});
